import types from '../mutation-types';

import { REPLY_EDITOR_MODES } from 'dashboard/components/widgets/WootWriter/constants';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import {
  contaLocalStorage,
  garantirMigracaoDeArmazenamento,
} from 'dashboard/helper/accountScopedStorage';

// A chave guarda `draft-<display_id da conversa>-<tipo>`, e display_id e
// sequencia POR CONTA: sem o id da conta no nome, o rascunho escrito para o
// cliente de uma conta reaparecia dentro de outra. A leitura no boot e segura
// porque a troca de conta e recarga dura da pagina, entao a URL ja tem a conta
// certa quando este modulo e avaliado.
const carregarRegistros = () => {
  garantirMigracaoDeArmazenamento();
  return contaLocalStorage.getJSON(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES, {}) || {};
};

const gravarRegistros = registros =>
  contaLocalStorage.setJSON(LOCAL_STORAGE_KEYS.DRAFT_MESSAGES, registros);

const state = {
  records: carregarRegistros(),
  replyEditorMode: REPLY_EDITOR_MODES.REPLY,
};

export const getters = {
  get: _state => key => {
    return _state.records[key] || '';
  },
  getReplyEditorMode: _state => _state.replyEditorMode,
};

export const actions = {
  set: async ({ commit }, { key, message }) => {
    commit(types.SET_DRAFT_MESSAGES, { key, message });
  },
  delete: ({ commit }, { key }) => {
    commit(types.SET_DRAFT_MESSAGES, { key });
  },
  setReplyEditorMode: ({ commit }, { mode }) => {
    commit(types.SET_REPLY_EDITOR_MODE, { mode });
  },
};

export const mutations = {
  [types.SET_DRAFT_MESSAGES]($state, { key, message }) {
    $state.records = {
      ...$state.records,
      [key]: message,
    };
    gravarRegistros($state.records);
  },
  [types.REMOVE_DRAFT_MESSAGES]($state, { key }) {
    const { [key]: draftToBeRemoved, ...updatedRecords } = $state.records;
    $state.records = updatedRecords;
    gravarRegistros($state.records);
  },
  [types.SET_REPLY_EDITOR_MODE]($state, { mode }) {
    $state.replyEditorMode = mode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
